import { useState } from "react";
import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "./Sidebar";

export default function AppLayout() {
  const { user, loading } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get("embed") === "true" || (typeof window !== "undefined" && window.parent !== window);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-[#F9F9FB]">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#111216] border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (isEmbed) {
    return (
      <div className="flex h-screen overflow-hidden" data-testid="app-layout-embed">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
        <main className="flex-1 overflow-hidden flex flex-col bg-[#F9F9FB]">
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden" data-testid="app-layout">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <main className="flex-1 overflow-hidden flex flex-col bg-[#F9F9FB]">
        <Outlet />
      </main>
    </div>
  );
}
